import type { DatasetImageItemProps } from "./dataset-image-item.type";

import { DatasetImageNode } from "@/modules/dataset-image/dataset-image-node";

export const DatasetImageItem = ({
  imageFile,
  dataset,
  isThumbnail,
}: DatasetImageItemProps) => {
  const datasetSrc = isThumbnail
    ? dataset?.data_path
    : dataset?.data_download_path;

  const src = datasetSrc ?? imageFile?.url;
  const alt = dataset?.name ?? imageFile?.name;

  if (!src) return null;

  return (
    <DatasetImageNode
      src={src}
      alt={alt}
      labeling={dataset?.labeling_object}
      hideBoundingBoxLabels={isThumbnail}
    />
  );
};
